var _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuadroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.399,
    height: 44,
    viewBox: "0 0 251.399 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_52239",
    "data-name": "Raggruppa 52239",
    transform: "translate(-279 -123)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(-148.331 349.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8",
    "data-name": "Tracciato 8",
    d: "M261.549-345.366v44h44v-44Zm38.6,38.663H291.2v-1.958h-22.36v-29.413h29.41v22.424h1.9Z",
    transform: "translate(165.782 119.339)",
    fill: "#2b373f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2",
    "data-name": "Rettangolo 2",
    width: 12.593,
    height: 12.593,
    transform: "translate(455.574 -210.636) rotate(90)",
    fill: "#2b373f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Q_U_A_D_R_O",
    "data-name": "Q U A D R O",
    transform: "translate(348 130.939)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M304.4-327.612a11.863,11.863,0,0,1-.524,3.562,10.613,10.613,0,0,1-1.488,3.009l3.732,3.732-3.285,2.684-3.663-3.613a10.377,10.377,0,0,1-2.468.938,11.705,11.705,0,0,1-2.778.319,9.977,9.977,0,0,1-7.534-3.012,10.555,10.555,0,0,1-2.888-7.619v-4.5a10.574,10.574,0,0,1,2.88-7.611,9.9,9.9,0,0,1,7.509-3.021,10.085,10.085,0,0,1,7.584,3.021,10.5,10.5,0,0,1,2.924,7.611Zm-5-4.539a7.583,7.583,0,0,0-1.462-4.8,4.848,4.848,0,0,0-4.042-1.873,4.689,4.689,0,0,0-3.965,1.873,7.728,7.728,0,0,0-1.42,4.8v4.539a7.781,7.781,0,0,0,1.429,4.852,4.726,4.726,0,0,0,3.989,1.873,4.793,4.793,0,0,0,4.024-1.873,7.719,7.719,0,0,0,1.446-4.852Z",
    transform: "translate(-283.504 342.747)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M319.015-342.583v16.392a8.239,8.239,0,0,1-2.8,6.622,10.834,10.834,0,0,1-7.274,2.391,10.706,10.706,0,0,1-7.234-2.391,8.274,8.274,0,0,1-2.776-6.622v-16.392h5.039v16.392a5.153,5.153,0,0,0,1.341,3.835,4.938,4.938,0,0,0,3.63,1.325,5.055,5.055,0,0,0,3.681-1.325,5.116,5.116,0,0,0,1.358-3.835v-16.392Z",
    transform: "translate(-264.975 342.944)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M328.155-322.941h-8.117l-1.686,5.4h-5.246l8.445-25.042h5.143l8.412,25.042h-5.246Zm-6.88-3.938h5.66l-2.769-8.824h-.1Z",
    transform: "translate(-247.939 342.944)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_4",
    "data-name": "Tracciato 4",
    d: "M328.176-317.541v-25.042h8.738a10.334,10.334,0,0,1,7.567,2.935,10.112,10.112,0,0,1,2.976,7.523v4.145a10.082,10.082,0,0,1-2.976,7.525,10.363,10.363,0,0,1-7.567,2.915Zm5.022-21.172v17.319h3.716a4.907,4.907,0,0,0,3.989-1.847,7.246,7.246,0,0,0,1.515-4.74v-4.178a7.184,7.184,0,0,0-1.515-4.713,4.915,4.915,0,0,0-3.989-1.84Z",
    transform: "translate(-229.83 342.944)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_5",
    "data-name": "Tracciato 5",
    d: "M347.768-327.549v10.008h-5.022v-25.042h8.67a10.394,10.394,0,0,1,6.7,1.953,6.61,6.61,0,0,1,2.415,5.444,5.5,5.5,0,0,1-1.024,3.329,7.141,7.141,0,0,1-2.983,2.261,5.389,5.389,0,0,1,3.19,2.184,6.932,6.932,0,0,1,.973,3.784v1.84a9.11,9.11,0,0,0,.282,2.193,3,3,0,0,0,.973,1.693v.361h-5.178a2.772,2.772,0,0,1-.885-1.823,15.69,15.69,0,0,1-.2-2.459V-323.6a3.984,3.984,0,0,0-1.024-2.915,3.883,3.883,0,0,0-2.9-1.039Zm0-3.87h3.562a4.715,4.715,0,0,0,3.146-.894,3.314,3.314,0,0,0,1.033-2.651,3.65,3.65,0,0,0-1.041-2.734,4.2,4.2,0,0,0-3.051-1.015h-3.648Z",
    transform: "translate(-212.325 342.944)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6",
    "data-name": "Tracciato 6",
    d: "M377.534-327.612a10.524,10.524,0,0,1-2.906,7.628,10.069,10.069,0,0,1-7.569,3,9.977,9.977,0,0,1-7.534-3.012,10.555,10.555,0,0,1-2.888-7.619v-4.5a10.574,10.574,0,0,1,2.88-7.611,9.9,9.9,0,0,1,7.507-3.021,10.087,10.087,0,0,1,7.586,3.021,10.5,10.5,0,0,1,2.924,7.611Zm-5.006-4.539a7.57,7.57,0,0,0-1.462-4.8,4.843,4.843,0,0,0-4.042-1.873,4.685,4.685,0,0,0-3.963,1.873,7.729,7.729,0,0,0-1.42,4.8v4.539a7.781,7.781,0,0,0,1.429,4.852,4.727,4.727,0,0,0,3.989,1.873,4.8,4.8,0,0,0,4.024-1.873,7.718,7.718,0,0,0,1.444-4.852Z",
    transform: "translate(-195.635 342.747)",
    fill: "#2b373f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadroLogo);
export default __webpack_public_path__ + "static/media/quadro_logo.c81617ca8fb00c9c98066c96a9ddabc8.svg";
export { ForwardRef as ReactComponent };